import { isoZ, z } from 'my-zod'

export const customerPostRideSurveyResultsV2Model = z.object({
  outfitterId: z.number(),
  riderId: z.string(),
  surveyRating: z.number(),
  surveyComments: z.string().nullable(),
  chosenReviewMethod: z.string().nullable(),
  createdDate: isoZ.instant()
})

export type customerPostRideSurveyResultsV2Model = z.infer<typeof customerPostRideSurveyResultsV2Model>
